import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Allows trusted HTML to be rendered without stripping off some tags and attributes. This can work in conjunction with any HTML or XML string.
 * This though can expose the app to XSS attacks. Please work with the teams to make sure it is trusted and valid HTML.
 *
 * Example : <div [innerHTML]="externalHtmlString | safe" />, where externalHtmlString = '<span>Hello World</span><script>alert('hello world!');</script>'
 *
 * The above example would still render the span together with the script tag and outputs an alert to the user.
 */
@Pipe({
  name: 'safe'
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
